import { render } from "./NumberPageBlock.vue?vue&type=template&id=7822ab28"
import script from "./NumberPageBlock.vue?vue&type=script&lang=js"
export * from "./NumberPageBlock.vue?vue&type=script&lang=js"

import "./NumberPageBlock.vue?vue&type=style&index=0&id=7822ab28&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__